import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/location/8.jpg")